import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  FormGroup,
} from "reactstrap";
import { categories } from "../../enums/CategoriesEnum";
import { types } from "../../enums/TypesEnum";
import { Cosmetic, CreateCosmetic } from "../../models/Cosmetic";
import { cosmeticService } from "../../services/cosmeticService";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import * as imageService from "../../services/imageService";
import * as brandsClient from "../../clients/brandsClient";
import { Brand } from "../../models/Brand";

type Props = {
  toggle: boolean;
  setToggle: Function;
  cosmetics: Cosmetic[];
  setCosmetics: Function;
};

const CreateModal = ({ toggle, setToggle, setCosmetics, cosmetics }: Props) => {
  const populateBrands = async () => {
    setBrands(
      (await brandsClient.getBrands()).map((brand, index) => ({
        id: index,
        name: brand.name,
      }))
    );
  };

  useEffect(() => {
    populateBrands();
  }, []);

  const names = [...new Set(cosmetics.map((x) => x.name))].map(
    (value, index) => ({ id: index, name: value })
  );

  const [brands, setBrands] = useState<Brand[]>([]);
  const [name, setName] = useState<string>("");
  const [brand, setBrand] = useState<string>("");
  const [category, setCategory] = useState<string>(categories[0].value);
  const [type, setType] = useState<string>("");
  const [color, setColor] = useState<string>("");
  const [grade, setGrade] = useState<number>(1);
  const [comment, setComment] = useState<string>("");
  const [baseImage, setBaseImage] = useState<any>("");

  const [invalid, setInvalid] = useState<boolean>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const addReview = async () => {
    if (
      !name ||
      !comment ||
      !brand ||
      name.length < 1 ||
      comment.length < 1 ||
      brand.length < 1
    ) {
      setInvalid(true);
      return;
    }
    setIsLoading(true);
    let create: CreateCosmetic = {
      name: name,
      brand: brand,
      category: category,
      type: type,
      color: color.length < 1 ? "default" : color,
      grade: grade,
      comment: comment,
      image: baseImage,
    };
    try {
      let newReview = await cosmeticService.addReview(create);
      let exists = cosmetics.find(
        (x) =>
          x.name === newReview.name &&
          x.brand === newReview.brand &&
          x.type === newReview.type &&
          x.category === newReview.category
      );
      if (exists) {
        let copy = [...cosmetics];
        let index = cosmetics.indexOf(exists);
        copy[index] = newReview;
        setCosmetics(copy);
      } else {
        let cos = [...cosmetics];
        cos.unshift(newReview);
        setCosmetics(cos);
      }
      setToggle(false);
      setIsLoading(false);
    } catch {
      alert("Problemy przepraszamy");
      setIsLoading(false);
    }
  };

  const cancel = async () => {
    setInvalid(undefined);
    setToggle(!toggle);
  };

  const notes = [1, 2, 3, 4, 5];
  const language = "pl";

  const uploadImage = (e: any) => {
    imageService.uploadImage(e, setBaseImage);
  };

  return (
    <Modal isOpen={toggle} toggle={() => cancel()}>
      <Form>
        <ModalHeader toggle={() => cancel()}>Dodaj kosmetyk</ModalHeader>
        <ModalBody>
          Marka <span style={{ color: "red" }}>*</span>
          <ReactSearchAutocomplete
            showIcon={false}
            items={brands}
            onSelect={(item: any) => setBrand(item.name)}
            onSearch={(item: any) => setBrand(item)}
            autoFocus
            onClear={() => setBrand("")}
            styling={{
              borderRadius: "0.25rem",
              border: "1px solid #ced4da",
              boxShadow: "lightblue 2px 1px 6px 2px",
              zIndex: 1002,
            }}
          />
          Nazwa <span style={{ color: "red" }}>*</span>
          <ReactSearchAutocomplete
            showIcon={false}
            items={names}
            onSelect={(item: any) => setName(item.name)}
            onSearch={(item: any) => setName(item)}
            autoFocus
            onClear={() => setName("")}
            styling={{
              borderRadius: "0.25rem",
              border: "1px solid #ced4da",
              boxShadow: "lightblue 2px 1px 6px 2px",
              zIndex: 1001,
            }}
          />
          Kategoria
          <Input
            type="select"
            onChange={(e) => {
              setCategory(e.target.value);
            }}
          >
            {categories.map((x) => (
              <option key={x.value} value={x.value}>
                {x.translations.find((y) => y.language === language)?.name}
              </option>
            ))}
          </Input>
          Typ
          <Input type="select" onChange={(e) => setType(e.target.value)}>
            <option key={"other"} value={"other"}>
              inny
            </option>
            {types
              .find((x) => x.category === category)
              ?.values.map((xx) => (
                <option key={xx.value} value={xx.value}>
                  {xx.translations.find((y) => y.language === language)?.name}
                </option>
              ))}
          </Input>
          Odcień (opcjonalnie)
          <Input type="text" onChange={(e) => setColor(e.target.value)} />
          Ocena
          <div>
            {notes.map((note) => (
              <FormGroup key={note} check inline>
                <Label>
                  <Input
                    type="radio"
                    name="note"
                    value={note}
                    onChange={(e) => setGrade(parseInt(e.target.value))}
                  />
                  {note}
                </Label>{" "}
              </FormGroup>
            ))}
          </div>
          Komentarz <span style={{ color: "red" }}>*</span>
          <Input
            invalid={invalid && !comment}
            type="textarea"
            onChange={(e) => setComment(e.target.value)}
          />
          Zdjęcie
          <Input type="file" onChange={(e) => uploadImage(e)} />
        </ModalBody>
        <ModalFooter>
          {invalid && (!brand || !name || !comment) && (
            <div style={{ color: "red" }}>
              Marka, Nazwa, Komentarz są wymagane
            </div>
          )}
          {isLoading ? (
            <div className="spinner" />
          ) : (
            <>
              <Button
                className="single-btn"
                color="primary"
                onClick={() => addReview()}
              >
                Dodaj
              </Button>{" "}
              <Button color="secondary" onClick={() => cancel()}>
                Anuluj
              </Button>
            </>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CreateModal;
